(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-post-with-sidebar"] && !Shopify.designMode) return;
  try {
    
  // Guard: section may not exist on every page (e.g. other pages). Skip JS
  // entirely if the scroll container isn't in the DOM.
  const container = document.querySelector('.blog-post-with-sidebar__right > div');
  if (!container) return;

  const onTab = (e) => {
    if (e.key === 'Tab') container.classList.add('is-tabbing');
  };
  const offTab = () => container.classList.remove('is-tabbing');

  document.addEventListener('keydown', onTab);
  document.addEventListener('wheel', offTab, { passive: true });
  document.addEventListener('mousedown', offTab);
  document.addEventListener('touchstart', offTab, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // PASSWORD
    const togglePassword = document.getElementById('togglePassword');
    const passwordField = document.getElementById('passwordField');
    const eyeOpenPassword = document.getElementById('password-icon-open');
    const eyeHidePassword = document.getElementById('password-icon-hide');

    if (togglePassword && passwordField) {
      togglePassword.addEventListener('click', function () {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          eyeOpenPassword.classList.remove('d:none');
          eyeHidePassword.classList.add('d:none');
        } else {
          passwordField.type = 'password';
          eyeOpenPassword.classList.add('d:none');
          eyeHidePassword.classList.remove('d:none');
        }
      });
    }

    // CONFIRM PASSWORD
    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword');
    const confirmPasswordField = document.getElementById('confirmPasswordField');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide');

    if (toggleConfirmPassword && confirmPasswordField) {
      toggleConfirmPassword.addEventListener('click', function () {
        if (confirmPasswordField.type === 'password') {
          confirmPasswordField.type = 'text';
          eyeOpenConfirmPassword.classList.remove('d:none');
          eyeHideConfirmPassword.classList.add('d:none');
        } else {
          confirmPasswordField.type = 'password';
          eyeOpenConfirmPassword.classList.add('d:none');
          eyeHideConfirmPassword.classList.remove('d:none');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
